/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { GetPartnerSettings200ResponseDataInner } from './GetPartnerSettings200ResponseDataInner'
import {
  GetPartnerSettings200ResponseDataInnerFromJSON,
  GetPartnerSettings200ResponseDataInnerFromJSONTyped,
  GetPartnerSettings200ResponseDataInnerToJSON,
} from './GetPartnerSettings200ResponseDataInner'

/**
 *
 * @export
 * @interface GetPartnerSettings200Response
 */
export interface GetPartnerSettings200Response {
  /**
   *
   * @type {boolean}
   * @memberof GetPartnerSettings200Response
   */
  status: boolean
  /**
   *
   * @type {Array<GetPartnerSettings200ResponseDataInner>}
   * @memberof GetPartnerSettings200Response
   */
  data: Array<GetPartnerSettings200ResponseDataInner>
}

/**
 * Check if a given object implements the GetPartnerSettings200Response interface.
 */
export function instanceOfGetPartnerSettings200Response(
  value: object
): value is GetPartnerSettings200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function GetPartnerSettings200ResponseFromJSON(
  json: any
): GetPartnerSettings200Response {
  return GetPartnerSettings200ResponseFromJSONTyped(json, false)
}

export function GetPartnerSettings200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetPartnerSettings200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: (json['data'] as Array<any>).map(
      GetPartnerSettings200ResponseDataInnerFromJSON
    ),
  }
}

export function GetPartnerSettings200ResponseToJSON(
  value?: GetPartnerSettings200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: (value['data'] as Array<any>).map(
      GetPartnerSettings200ResponseDataInnerToJSON
    ),
  }
}
